<template>
  <div @click.stop class="popup_back">
    <!-- 模板列表页 -->
    <div v-if="activePage == 0" class="flex_wrap">
      <div class="pdf_item column" v-for="(item, index) in activePDFList" :key="index" @click.stop="selectTemplate(item)">
        <img v-if="item?.modelContent" class="pdf_cover" :src="item?.modelContent" alt="" />
        <div v-else class="empty_back flex"></div>
        <span class="pdf_title ellipsis">{{ item.modelName }}</span>
      </div>
      <div class="page_area flex">
        <div class="page_num" :class="{ active_page_num: index + 1 == activePageNum }" v-for="(item, index) in pageNum"
          :key="index" @click.stop="activePageNum = index + 1"></div>
      </div>
    </div>
    <!-- 模板详情页 -->
    <div v-if="activePage == 1">
      <div class="head flex">
        <img @click.stop="activePage = 0" class="arrow" src="@/assets/img/arrow_3.png" alt="" />
        <span @click.stop="activePage = 0">
          {{ activeTemplate.modelName }}</span>
      </div>
      <div class="flex_wrap">
        <div class="page_item" v-for="(item, index) in activeItemList" :key="index + 'pdfInfoList'"
          @click.stop="toShowImg(item.remark)">
          <img :src="item.remark" alt="" />
        </div>
      </div>
      <div class="page_area flex">
        <div class="page_num" :class="{ active_page_num: index + 1 == activePageNum2 }" v-for="(item, index) in pageNum2"
          :key="index + 'activePageNum2'" @click.stop="activePageNum2 = index + 1"></div>
      </div>
      <div class="select" @click.stop="useConfirm">应用整套模板</div>
    </div>
  </div>
</template>
          
<script>
import { pdfModelList } from "@/assets/js/request";
import { mapState, mapMutations } from "vuex";
export default {
  components: {},
  data() {
    return {
      activePage: 0, //0-模板列表页  1-模板详情页
      workList: [], //当前条件下的总数据列表
      activePageNum: 1, //模板列表页-当前显示的页数
      total: 0, //板列表页-总数据数
      activePageNum2: 1, //模板详情页-当前显示的页数
      activeTemplate: {}, //当前选中模板
    };
  },
  computed: {
    ...mapState(["userInfo", "paramsId"]),
    //当前渲染展示的列表
    activePDFList() {
      return this.workList.slice(
        (this.activePageNum - 1) * 10,
        this.activePageNum * 10
      );
    },
    activeItemList() {
      return this.activeTemplate.pdfInfoList.slice(
        (this.activePageNum2 - 1) * 10,
        this.activePageNum2 * 10
      );
    },
    pageNum() {
      return Math.ceil(this.total / 10);
    },
    pageNum2() {
      return Math.ceil(this.activeTemplate.pdfInfoList.length / 10);
    },
  },
  methods: {
    selectTemplate(item) {
      this.activeTemplate = item;
      this.activePage = 1;
    },
    useConfirm() {
      this.$emit("checkTemplate", this.activeTemplate.id)
      this.$emit("close");
    },
    toShowImg(url) {
      window.open(url, "_blank");
    },
  },
  created() {
    pdfModelList({
      pageSize: "10",
      pageNum: this.activePageNum,
    }).then((res) => {
      if (res.code == 200) {
        this.workList = res.data.rows;
        this.total = res.data.total;
      }
    });
  },
};
</script>
          
<style lang="scss" scoped>
.popup_back {
  position: absolute;
  top: 34px;
  left: 0;
  width: 936px;
  height: 328px;
  background: #ffffff;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px;
  border: 1px solid #eeeeee;
  padding: 20px;
  z-index: 3;

  .flex_wrap {
    display: flex;
    flex-wrap: wrap;
  }

  .pdf_item {
    margin-right: 23px;
    margin-bottom: 20px;
    position: relative;
    cursor: pointer;

    &:nth-of-type(5n) {
      margin-right: 0;
    }

    .pdf_cover {
      width: 160px;
      height: 90px;
    }

    .empty_back {
      width: 160px;
      height: 90px;
      background: #ffffff;
      border: 1px solid #eeeeee;
    }

    .pdf_title {
      width: 160px;
      height: 22px;
      font-size: 14px;
      color: #242424;
      line-height: 22px;
      margin-top: 8px;
    }

    .pdf_time {
      height: 22px;
      font-size: 14px;
      color: #242424;
      line-height: 22px;
    }
  }

  .page_area {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);

    .page_num {
      width: 8px;
      height: 8px;
      background: #000000;
      border-radius: 50%;
      opacity: 0.15;
      margin-right: 6px;
      cursor: pointer;
    }

    .active_page_num {
      opacity: 0.5;
    }
  }

  .head {
    font-size: 12px;
    color: #242424;
    margin-bottom: 20px;

    .arrow {
      width: 16px;
      height: 16px;
      transform: rotate(90deg);
      margin-right: 6px;
    }
  }

  .page_item {
    width: 160px;
    height: 90px;
    margin-right: 23px;
    margin-bottom: 20px;
    cursor: pointer;

    &:nth-of-type(5n) {
      margin-right: 0;
    }

    >img {
      width: 100%;
      height: 100%;
    }
  }

  .select {
    width: 104px;
    height: 32px;
    background: #242424;
    border-radius: 100px 100px 100px 100px;
    text-align: center;
    line-height: 32px;
    font-size: 12px;
    color: #f3f3f3;
    position: absolute;
    bottom: 20px;
    left: 20px;
  }
}
</style>
          